import { Stack } from "@mui/material";
import React, { ReactElement, useCallback, useMemo } from "react";
import { ReportType } from "../../abstract/Report";
import InfoRow from "../../components/InfoRow";
import { colors } from "../../theme";
import { getAge } from "../../utils";
import { FertilizationMethod, GetCycleResponseItem } from "./types";
import { useApp } from "../../contexts/AppContext";
interface PatientInfoCardProps {
  cycle: GetCycleResponseItem;
  onExpand: () => void;
  type: ReportType;
}

const PatientInfoCard: React.FC<PatientInfoCardProps> = ({
  cycle,
  onExpand,
  type,
}) => {

  const patient = {
    ...cycle,
    name: cycle.patient,
    created: new Date(cycle.created),
  };

  const patientInfoRow = useCallback(
    (label: string, value: string | number | ReactElement, date?: Date) => (
      <InfoRow labelWidth={220} label={label} value={value} date={date} />
    ),
    []
  );
const { translate } = useApp();
  const translations = useMemo(() => translate("embryo"), [translate]);

  return (
    <Stack
      sx={
        type === "report"
          ? { backgroundColor: colors.stone[50], borderRadius: 4, padding: 2 }
          : {}
      }
      direction="row"
      justifyContent="space-between"
      alignItems={"flex-start"}
    >
      <Stack direction="row" spacing={12} alignItems={"flex-start"}>
        <Stack spacing={2} maxWidth={320}>
          {patientInfoRow(translations.patientInfo.labels.name, patient.name)}
          {patientInfoRow(
            translations.patientInfo.labels.oocyteProviderAge,
            getAge(new Date(patient.birth))
          )}
        </Stack>
        <Stack spacing={2} maxWidth={320}>
          {patient.transfer &&
            patientInfoRow(translations.patientInfo.labels.scheduledTransferDate, patient.transfer)}
          {patientInfoRow(
            translations.patientInfo.labels.fertilizationMethod,
            patient.fertilization === FertilizationMethod.ICSI ? "ICSI" : "IVF"
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PatientInfoCard;
